import PropTypes from 'prop-types'
import { Element } from '../html/element'
import classes from './index.module.scss'

export const ButtonSubmit = ({ submit }) => {
  return (
    <Element
      elementName="button"
      onClick={submit}
      className={classes.buttonSubmit}
      style={{ backgroundColor: '#2c73e8', color: '#FFFFFF' }}
    >
      OK
    </Element>
  )
}

ButtonSubmit.propTypes = {
  submit: PropTypes.func,
}

ButtonSubmit.defaultProps = {
  submit: () => {},
}
